// strona importu produktów w panelu administracyjnym

import React, { ChangeEventHandler, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { usePostPanelProductsImport } from 'api';
import { reduxActions, useDispatch } from 'store';
import { PageTitle, Button, FileUploader } from 'components/controls';

import styles from 'theme/pages/PanelProductsImport/PanelProductsImport.module.scss';

const PanelProductsImport = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [base64File, setBase64File] = useState('');
  const [fileName, setFileName] = useState('');

  useEffect(() => {
    dispatch(
      reduxActions.setBreadcrumbs([
        { name: t('Panel'), path: '/managment_panel' },
        { name: t('Import produktów') }
      ])
    );
  }, []);

  const createBase64File = (file: Blob): Promise<string | undefined> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result?.toString().replace(/^data:(.*,)?/, ''));
      reader.onerror = (error) => reject(error);
    });

  const handleFileInputChange: ChangeEventHandler<HTMLInputElement> = async (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileName(file.name);
      setBase64File((await createBase64File(file)) || '');
    }
  };

  const { mutate: importProducts, isLoading } = usePostPanelProductsImport({
    onSuccess: () => {
      setBase64File('');
      setFileName('');
    }
  });

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Pages-PanelProductsImport'
      )}>
      <PageTitle title={t('Import produktów')} />

      <div className={styles.importWrapper}>
        <div className={styles.title}>
          <Trans>Importuj produkty z pliku CSV</Trans>
        </div>

        <div className={styles.form}>
          <FileUploader
            buttonLabel={t('Przeglądaj')}
            onChange={handleFileInputChange}
            file={fileName}
          />

          <Button
            loading={isLoading}
            disabled={isLoading || !base64File}
            onClick={() => importProducts({ file: base64File })}>
            <Trans>Importuj produkty</Trans>
          </Button>
        </div>

        <div className={styles.examples}>
          <Trans>Tutaj jest przykładowy plik</Trans>:{' '}
          <a
            href={`${process.env.REACT_APP_API_BASE_URL}/files/example_data/products.csv`}
            target="_blank"
            rel="noreferrer">
            products.csv
          </a>
        </div>
      </div>
    </div>
  );
};

export default PanelProductsImport;
